<!-- eslint-disable -->
<template>
  <div
    v-loading="loading && !noLoading"
    style="width: 100%;"
  >
    <normal-table
      :prohibitUploading="prohibitUploading"
      :notip="notip"
      :apiName="apiName"
      :opt="metas.opt"
      :tableId="id"
      :uploadType="uploadType"
      class="kr-table-normal"
      v-if="type === 'normal'"
      ref="krTable"
      :disabled="disabled"
      :editClick="editClick"
      :editShow="editShow"
      :isSingle="isSingle"
      :expand="tableProps.expand"
      :tableProps="tableProps"
      :expand-details="expandDetails"
      :fix-first-column="tableProps.fixFirstColumn"
      :header-data="headerData"
      :height="height"
      :max-height="maxheight || tableProps.maxHeight"
      :meta-data="metaData"
      :refer="refer"
      :options="tableProps.options"
      :pristine-settings="getMenu"
      :query="tableProps.query"
      :redirects="tableProps.redirects"
      :related="tableProps.related"
      :favourite="tableProps.favourite"
      :relation="tableProps.relation"
      :relation-attrs="tableProps.relationAttrs"
      :rowspan="tableProps.rowspan"
      :selection="tableProps.selection"
      :settings="getMenu"
      :settings-type="tableProps.settingsType"
      :show-set-header="showSetHeader"
      :force-set-header="tableProps.forceSetHeader"
      :table-data="tableData"
      :filter-metas="filterMetas"
      :activation-table-setting="tableProps.activationTableSetting"
      :cell-style="metas.cellStyle"
      :source="source"
      :MessageDialog="MessageDialog"
      :selectable="selectable"
      :check-box-all-show="checkBoxAllShow"
      v-bind="$attrs"
      @cellClick="cellClick"
      @popoverTable="popoverTable"
      @checkboxChange="checkboxChange"
      @getSelectionRows="getSelectionRows"
      @handelHeaderCheckbox="handelHeaderCheckbox"
      @handleSetHeader="handleSetHeader"
      @settingsClick="settingsClick"
      @referenceClick="referenceClick"
      @onFilter="handleFilter"
      @relatedClick="relatedClick"
      @favouriteClick="favouriteClick"
      @handleSort="handleSort"
      @headerDragend="handleHeaderDrag"
      @sort-change="sortChange"
      @filter-change="filterChange"
      @messageChange="messageChange"
      @handelLink="handelLink"
    >
      <template slot="empty">
        <slot name="empty" />
      </template>
    </normal-table>
    <edit-table
      v-if="type === 'edit'"
      ref="krTable"
      :table-data="tableData"
      :header-data="headerData"
      :max-height="maxheight || tableProps.maxHeight"
      :height="height"
      :disabled="disabled"
      :source="source"
      v-bind="$attrs"
      @checkboxChange="checkboxChange"
      @radioChange="radioChange"
      @headerRadioChange="headerRadioChange"
    />
    <kr-table-by-gm
      class="kr-table-gm"
      v-if="type === 'gm'"
      ref="krTable"
      :header-data="headerData"
      :table-data="tableData"
      :isSingle="isSingle"
      :table-props="tableProps"
      :meta-data="metaData"
      :settings="getMenu"
      :filter-metas="filterMetas"
      @end="renderEnd"
      @settingsClick="settingsClick"
      @getSelectionRows="getSelectionRows"
      @handleSort="handleSort"
      @handleSetHeader="handleSetHeader"
      @onFilter="handleFilter"
      @favouriteClick="favouriteClick"
      @headerDragend="handleHeaderDrag"
      @moveRowAfter="moveRowAfter"
      @sort-change="sortChange"
      @filter-change="filterChange"
    />
    <!-- TODO: 统一添加 headerData 为空数组的 placeholder -->
    <!-- <template v-if="headerData && headerData.length">
    </template>
    <div v-else class="empty-block">
      暂无数据
    </div> -->
    <kr-pagination
      v-if="getShowPagination && isShowPagination"
      :pagination-config="pageInfo"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />
    <!-- 设置显示列 -->
    <kr-dialog
      v-if="setHeaderDialog.visible"
      v-bind="setHeaderDialog"
      :visible.sync="setHeaderDialog.visible"
      :append-to-body="true"
    >
      <div v-loading="setHeaderDialog.loading">
        <data-form
          v-if="!setHeaderDialog.loading"
          ref="setHeaderForm"
          :value="setHeaderDialog.value"
          :field-metas="setHeaderDialog.metas"
        />
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="transfer-reset"
          size="mini"
          @click="resetHeaderDialog.visible = true"
        >恢复默认</el-button>
        <el-button
          size="mini"
          @click="setHeaderDialog.visible = false"
        >取消</el-button>
        <el-button
          size="mini"
          type="primary"
          :disabled="setHeaderDialog.loading"
          @click="handleSetHeaderConfirmBtn"
        >确定</el-button>
      </span>
    </kr-dialog>
    <el-dialog
      v-if="resetHeaderDialog.visible"
      append-to-body
      top="60px"
      :close-on-click-modal="false"
      :visible.sync="resetHeaderDialog.visible"
      :title="resetHeaderDialog.title"
    >
      <p class="reset-header-info">
        <i class="el-icon-warning info-warning" />
        <span class="info-text">是否确定要重置为系统设置的布局？</span>
      </p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="mini"
          @click="resetHeaderDialog.visible = false"
        >取 消</el-button>
        <el-button
          size="mini"
          type="primary"
          @click="handleResetHeader"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/*  eslint-disable */
import { isEqual, get } from 'lodash'
import normalTable from '../krTable/normalTable/index'
import editTable from '../krTable/editTable/index'
import KrPagination from '../krPagination'
import ajax from '@c/utils/request'
import DataForm from '../form/view/data-form'
import krTableByGm from '../krTableByGm/index'
import formatMixin from '@ins/mixin/formatList.js'
import { buttonShow } from '@publicUtils/tableButtonShow.js';
import moment from 'moment'
import { mapState } from 'vuex'
const {
  methods: { isSubjoinKey },
  data: mixinData,
} = formatMixin

export default {
  name: 'krDataTable',
  props: {
    prohibitUploading: {
      type: Boolean,
      default: false,
    },
    notip: {
      type: Boolean,
      default: false,
    },
    apiName:{
      type: String,
      default: ""
    },
    id: kr.vue.getPropString(),
    uploadType:{
      type: Object,
      default: () => ({})
    },
    noLoading: kr.vue.getPropBoolean(false),
    MessageDialog:kr.vue.getPropBoolean(),
    showSetHeader: kr.vue.getPropBoolean(true),
    metas: kr.vue.getPropObject(),
    expandDetails: kr.vue.getPropObject(),
    disabled: kr.vue.getPropBoolean(),
    isSingle: kr.vue.getPropBoolean(false),
    popover: Object,
    height: Number,
    maxheight: Number,
    type: kr.vue.getPropString('normal'),
    menuLabelName: kr.vue.getPropString(),
    emitFilter: kr.vue.getPropBoolean(false),
    fixedFn: Function,
    indexeddb: {
      // 本地缓存db对象
      type: Object,
      default: () => {
        return null
      },
    },
    indexeddb_source_key: kr.vue.getPropString(),
    source: kr.vue.getPropString(),
    defaultData: Object,
    editClick: Function,
    editShow: Boolean,
    layoutType: kr.vue.getPropString(),
    typeObject: kr.vue.getPropString(),
    checkBoxAllShow:  kr.vue.getPropBoolean(false),
    selectable: Function,
    lock: {
      type: Number,
      default: 0
    },
    fieldRight: String,
    objectApiName: String,
  },
  data() {
    return {
      ...mixinData(),
      isShowPagination: true, //是否显示分页组件
      setHeaderDialog: {
        loading: false,
        visible: false,
        title: '设置显示列',
        metas: [
          {
            key: 'viewFields',
            type: 'TRANSFER',
            innerName: 'viewFields',
            name: '',
            scene: {
              related_data: { options: [] },
            },
            description: null,
          },
        ],
        value: {},
      },
      resetHeaderDialog: {
        visible: false,
        title: '重置',
      },
      pageInfo: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      defaultPageLayout: 'total, sizes, prev, pager, next, jumper',
      headerData: [],
      tableData: [],
      tableProps: {
        menu: [],
      },
      refer: {},
      filterMetas: {},
      metaData: {},
      showHeader: [],
      prevPageSize: 1,
      showPagination: false,
      loading: false,
      skipPageChange: false, // 是否跳过当前组件的页码变更
      skipSortChange: false, // 是否跳过当前组件的排序变更
      filterCondList: [],
      sortParam: [],
      conditionList: [],
    }
  },
  components: {
    normalTable,
    editTable,
    krTableByGm,
    KrPagination,
    DataForm,
    KrDialog: require('../dialog/index.vue').default,
  },
  created() {
    let pageCurrentMemory =
      window.sessionStorage.getItem('pageCurrentMemory') || ''
    let name = this.$route.name
    if (pageCurrentMemory && this.metas.opt) {
      pageCurrentMemory = JSON.parse(pageCurrentMemory)
      if (
        name == 'mdSettingsBusinessCustomizationObjectManage' ||
        name == 'mdSettingsBusinessCustomizationTabManage' ||
        name == 'mdSettingsScriptManageConfig' ||
        name == 'mdSettingsScriptManageLog' ||
        name == 'mdSettingsMeetingManage' ||
        name == 'mdSettingsSecurityManageOperationLog' ||
        name == 'mdSettingsSecurityManageLoginLog' ||
        name == 'mdSettingsJurisdictionManageFunctionJurisdiction' ||
        name == 'mdSettingsBusinessCustomizationinGlobalVariable'
      ) {
        this.pageInfo.currentPage = pageCurrentMemory[name] || 1
      } else if (name == 'mdSettingsBusinessCustomizationinstrumentChange') {
        if (this.metas.opt.filters[0]) {
          if (this.metas.opt.filters[0].fieldValues[0]) {
            this.pageInfo.currentPage =
              pageCurrentMemory[
                this.metas.opt.filters[0].fieldValues[0].system_default
              ] || 1
          }
        }
      } else if (name == 'mdSettingsBusinessCustomizationObjectManageDetail') {
        if (this.typeObject) {
          this.pageInfo.currentPage = pageCurrentMemory[this.typeObject] || 1
        }
      } else {
        if (
          this.metas.opt.moduleInfoId == 'Object_41ix__u' ||
          this.metas.opt.moduleInfoId == 'project' ||
          this.metas.opt.moduleInfoId == 'company'
        ) {
          if (pageCurrentMemory[this.metas.opt.moduleInfoId]) {
            if (
              this.$route.query.mid ==
              pageCurrentMemory[this.metas.opt.moduleInfoId].menuId
            ) {
              this.pageInfo.currentPage =
                pageCurrentMemory[this.metas.opt.moduleInfoId].current || 1
            }
          }
        } else {
          this.pageInfo.currentPage =
            pageCurrentMemory[this.metas.opt.moduleInfoId] || 1
        }
      }
    }
    // console.log(this.pageInfo)
    this.handleSizeChange = _.debounce(this._handleSizeChange, 200)
    this.handleCurrentChange = _.debounce(this._handleCurrentChange, 200)
    let _value = this.$catche.find(this.source, this.indexeddb_source_key)

    if (_value) {
      this.pageInfo.pageSize = _value.pageSize
    }
    if (this.metas.opt && this.metas.opt.pageSize) {
      this.pageInfo.pageSize = this.metas.opt.pageSize
    }
  },
  mounted() {
    this.initSortParam()
    this.queryTableData()
  },
  computed: {
    ...mapState('user', ['roleName', 'otherRoleNames', 'userId']),
    getShowPagination() {
      const { layout } = this.pageInfo
      //有调整每页显示条数功能，不管total是否大于pageSize都要显示分页器
      if (layout && layout.includes('sizes')) {
        return this.pageInfo.total
      } else {
        return this.pageInfo.total > this.pageInfo.pageSize
      }
    },
    getMenu() {
      if (this.tableProps.menu && this.tableProps.menu !== null) {
        let multipleRolesIncludeDNAOrAdministrators = false
        this.otherRoleNames.forEach(item=>{
          if(item?.includes('DNA') || item?.includes('管理员')) {
            multipleRolesIncludeDNAOrAdministrators = true
          }
        })
        console.log("🚀 ~ api_back_filter",
          multipleRolesIncludeDNAOrAdministrators,
          this.roleName?.includes('管理员'),
          this.roleName?.includes('DNA')
        ) 
        if (
          !(
            this.roleName?.includes('管理员') ||
            this.roleName?.includes('DNA') ||
            multipleRolesIncludeDNAOrAdministrators
          )
        ) {
          this.tableProps.menu = this.tableProps.menu.filter(
            ({ command }) => command !== 'filetype|down',
          )
        }
        return this.tableProps.menu
      } else {
        return 'inData'
      }
    },
  },
  methods: {
    isSubjoinKey,
    getKrTable() {
      return this.$refs.krTable
    },
    renderEnd() {
      this.$emit('end')
      this.loading = false
    },
    handelLink(res) {
      this.$emit('handelLink', res)
    },
    // 初始化排序参数
    initSortParam() {
      let { orders } = this.$route.query
      // TODO: 通用处理 layoutMetas orders
      let { orders: layoutOrders = [] } = this.$attrs['layout-metas'] || {}
      try {
        if (orders) {
          orders = JSON.parse(orders)
        }
      } catch (e) {
        // empty
      }
      const initOrder = [
        ...(Array.isArray(orders) ? orders : []),
        ...layoutOrders,
      ]
      const hasInitOrder = initOrder.length
      if (hasInitOrder) {
        const order = initOrder[0]
        this.sortParam = [
          { fieldName: order.fn, asc: order.asc, subFieldName: order.sf },
        ]
        // 手动设置表格内排序状态
        this.getKrTable().setSortState({
          property: order.fn,
          order: order.asc ? 'asc' : 'desc',
        })
      }
    },
    moveRowAfter(...arg) {
      this.$emit('moveRowAfter', ...arg)
    },
    messageChange(value, row){
      this.$emit('messageChange',value, row)
    },
    // 标准版
    // async handleSort(e, param, property) {
    //   if (param) {
    //     this.sortParam = [{fieldName: property, asc: param === 'asc', subFieldName: "equivalentMoney"}];
    //   } else {
    //     this.sortParam = [];
    //   }

    //   if (!this.skipSortChange) {
    //     await this.queryTableData();
    //   }
    //   this.$emit('sortChange', this.sortParam);
    // },

    // vc-pe
    async handleSort(e, param, property) {
      this.sortParam = [
        {
          fieldName: property,
          asc: param === 'asc',
          subFieldName: 'equivalentMoney',
        },
      ]
      // 当前支持一层排序
      // const sortItem = this.sortParam.find((item) => {
      //   return item.fieldName === property;
      // })
      // if (sortItem) {
      //   this.sortParam.splice(sortItem, 1, { fieldName: property, asc: param === 'asc' });
      // } else {
      //   this.sortParam.push({ fieldName: property, asc: param === 'asc' });
      // }
      if (!this.skipSortChange) {
        await this.queryTableData()
      }
      this.$emit('sortChange', this.sortParam)
    },
    getFieldValues(value, item) {
      // 日期需要转换成时间戳
      if (
        this.dateField.includes(item.type) ||
        this.dateSceneType.includes(item?.filterMeta?.type || '')
      ) {
        if (item.operation.value !== 'BETWEEN') {
          return value.map(i => {
            return moment(i).unix() * 1000
          })
        }

        const filterType = item?.filterMeta?.type || ''

        // BETWEEN 需要截取
        const valueLists = value[0].split('至')
        return valueLists.map((i, index) => {
          return (
            moment(i).unix() * 1000 +
            (index == 1 && filterType !== 'DATE_TIME_RANGE'
              ? 24 * 3600 * 1000 - 1
              : 0)
          )
        })
      }
      // 数值期间范围需要先截取特殊处理
      if (
        this.numberField.includes(item.type) &&
        item.operation.value === 'BETWEEN'
      ) {
        // 区间类型 value数组中只会有一个
        return value[0].split('-')
      }
      // 如果是货币字段&&有附加筛选条件，需要根据附加条件判断是否需要对数据进行转换
      if (this.isSubjoinKey(item)) {
        // 是美元无需转换，是人民币需要6.5
        if (item.operationsSubjoin.value === 'CNY') {
          const num = ((value * 10000) / 6.5).toFixed(4)
          return [num]
        }
        return [value * 10000]
      }
      // 标签多级的话只保留最后一级
      if (this.tagField.includes(item.key)) {
        let valueList = value.map(i => {
          if (Array.isArray(i)) {
            return i[i.length - 1]
          }
          return i
        })
        valueList = _.uniq(valueList)
        return valueList
      }
      return value
    },
    getKrTable() {
      return this.$refs.krTable
    },
    renderEnd() {
      this.$emit('end')
      this.loading = false
    },
    sortChange({ sorts }) {
      const sort = sorts[0]
      this.handleSort({}, sort.dir, sort.key)
    },
    filterChange({ filters }) {
      let filtersList = [],
        oLength = this.conditionList.length,
        nLength = filters.length
      for (let i = 0; i < nLength; i++) {
        if (this.conditionList.length) {
          for (let j = 0; j < this.conditionList.length; j++) {
            if (this.conditionList[j].key === filters[i].key) {
              if (isEqual(this.conditionList[j], filters[i])) {
                this.conditionList.splice(j, 1)
                j--
              } else {
                filtersList.push(filters[i])
              }
            }
          }
        } else {
          filtersList.push(filters[i])
        }
      }
      filtersList = [...filtersList, ...this.conditionList]
      const [filter] = filtersList.length ? filtersList : filters
      const { key, operation, valueList } = filter
      this.handleFilter(
        {
          field: {
            filterKey: key,
            type: filter.filterMeta?.type || '',
          },
          relation: Object.keys(operation).length ? operation : null,
          value:
            oLength > nLength
              ? null
              : (() => {
                  let value = this.getFieldValues(valueList, filter)
                  return Array.isArray(value)
                    ? value.length === 1
                      ? value[0]
                      : value
                    : value
                })(),
        },
        filters,
      )

      this.conditionList = filters
    },
    handleFilter(val, filters) {
      if (this.emitFilter) {
        this.$emit('onFilter', val, filters)
        return
      }
      const { field, relation, value, dateRangeType } = val
      let { opt } = this.metas
      if (Array.isArray(value) ? value.length : value) {
        let filter = {
          filedName: field.filterKey,
          filedValues: Array.isArray(value) ? value : [value],
          dateRangeType,
        }
        if (relation) {
          filter.operator = relation.value
        }
        const index = this.filterCondList.findIndex(item => {
          return item.filedName === filter.filedName
        })
        if (index === -1) {
          this.filterCondList.push(filter)
        } else {
          this.filterCondList.splice(index, 1, filter)
        }
      } else {
        this.filterCondList = this.filterCondList.filter(item => {
          return item.filedName !== field.filterKey
        })
      }
      this.metas.opt.data = Object.assign({}, opt.data, {
        filterCondList: this.filterCondList,
      })
    },
    headerRadioChange() {
      this.$emit('headerRadioChange', ...arguments)
    },
    popoverTable(item, row, relation, relationAttrs, e) {
      this.$emit('popoverTable', item, row, relation, relationAttrs, e)
    },
    cellClick(data) {
      this.$emit('cellClick', data)
    },
    referenceClick(e, field) {
      this.$emit('referenceClick', e, field)
    },
    relatedClick(e, row) {
      this.$emit('relatedClick', e, row)
    },
    favouriteClick(e, row) {
      this.$emit('favouriteClick', e, row)
    },
    radioChange(...arg) {
      this.$emit('radioChange', ...arg)
    },
    checkboxChange(...arg) {
      this.$emit('checkboxChange', ...arg)
    },
    metadataChange(meta) {
      this.$emit('metadataChange', meta)
    },
    settingsClick(row, command, ...arg) {
      if(this.fieldRight){
        row.dialogFieldRight = this.fieldRight
      }
      if(this.objectApiName) {
        row.dialogObjectApiName = this.objectApiName
      }
      this.$emit('settingsClick', row, command, ...arg)
    },
    handelHeaderCheckbox(...arg) {
      this.$emit('handelHeaderCheckbox', ...arg)
    },
    handleHeaderDrag(...arg) {
      this.$emit('headerDragend', ...arg)
    },
    _handleSizeChange(size) {
      this.prevPageSize = this.pageInfo.currentPage
      this.pageInfo.pageSize = size
      if (!this.skipPageChange) {
        this.queryTableData()
      }
      this.$emit('pageChange', this.pageInfo)
      // pageSize indexeddb本地缓存
      if (this.indexeddb) {
        this.indexeddb.setItem(this.indexeddb_source_key, { pageSize: size })
      }
      // localStorage
      if (this.source) {
        this.$catche.save(this.source, {
          [`${this.indexeddb_source_key}`]: { pageSize: size },
        })
      }
    },
    _handleCurrentChange(val) {
      this.prevPageSize = this.pageInfo.currentPage
      let pageCurrentMemory =
        JSON.parse(window.sessionStorage.getItem('pageCurrentMemory')) || {}
      let name = this.$route.name
      if (
        name == 'mdSettingsBusinessCustomizationObjectManage' ||
        name == 'mdSettingsBusinessCustomizationTabManage' ||
        name == 'mdSettingsScriptManageConfig' ||
        name == 'mdSettingsScriptManageLog' ||
        name == 'mdSettingsMeetingManage' ||
        name == 'mdSettingsSecurityManageOperationLog' ||
        name == 'mdSettingsSecurityManageLoginLog' ||
        name == 'mdSettingsJurisdictionManageFunctionJurisdiction' ||
        name == 'mdSettingsBusinessCustomizationinGlobalVariable'
      ) {
        pageCurrentMemory[name] = val
      } else if (name == 'mdSettingsBusinessCustomizationinstrumentChange') {
        if (this.metas.opt.filters[0]) {
          if (this.metas.opt.filters[0].fieldValues[0]) {
            pageCurrentMemory[
              this.metas.opt.filters[0].fieldValues[0].system_default
            ] = val
          }
        }
      } else if (name == 'mdSettingsBusinessCustomizationObjectManageDetail') {
        if (this.typeObject) {
          pageCurrentMemory[this.typeObject] = val
        }
      } else {
        if (
          this.metas.opt.moduleInfoId == 'Object_41ix__u' ||
          this.metas.opt.moduleInfoId == 'project' ||
          this.metas.opt.moduleInfoId == 'company'
        ) {
          pageCurrentMemory[this.metas.opt.moduleInfoId] = {
            current: val,
            menuId: this.$route.query.mid || this.$route.params.menuCode,
          }
        } else {
          pageCurrentMemory[this.metas.opt.moduleInfoId] = val
        }
      }
      window.sessionStorage.setItem(
        'pageCurrentMemory',
        JSON.stringify(pageCurrentMemory),
      )

      this.pageInfo.currentPage = val
      if (!this.skipPageChange) {
        this.queryTableData()
      }
      this.$emit('pageChange', this.pageInfo)
    },
    // // 红黄当添加颜色
    async riskManagementRedYellow(data) {
      class redYellow {
        constructor(data) {
          this.result = data
        }
        // 后续有其他逻辑也可以在这里新建方法处理
        setSelfEvaluation() {
          if (this.result?.headerData) {
            this.result?.headerData.map((item) => {
              if (item.value === 'self_evaluation__u') {
                item.round = true
              }
            })
          }
          return this.result
        }
        // 获取所有的更改后的值
        getResult() {
          return this.setSelfEvaluation()
        }
      }
      return await new redYellow(data).getResult()
    },
    async queryTableData() {
      const vm = this
      const { sortParam = [] } = this
      const {
        api,
        opt,
        queryFieldsAPI,
        pageLayout,
        pageBackground,
        pageSizes,
        redirects,
        skipPageChange,
        skipSortChange,
        selection,
        related,
        favourite,
        api_back_filter,
        fixFirstColumn,
        settingsType,
        forceSetHeader,
        allPages,
        isShowPagination,
        supportMoveRow,
        moveRowKey,
      } = this.metas
      const { objectDescribeApiName } = _.get(this.metas,'opt') || {};
      const layoutMetas = this.$attrs['layout-metas'] || {}
      const { filters, hidePagination = false } = layoutMetas

      if (api) {
        vm.loading = true
        let param = {
          menuId: this.$route.query.mid || this.$route.params.menuCode,
        }
        if (!allPages) {
          param = {
            ...param,
            currentPage: vm.pageInfo.currentPage,
            pageSize: vm.pageInfo.pageSize,
          }
        }
        param = sortParam.length
          ? Object.assign(param, { orders: sortParam })
          : param
        try {
          let res = null
          // 扩展 metas.api
          if (typeof api === 'string') {
            const options = kr.script.updateState(
              {
                method: 'post',
                url: api,
              },
              {
                data: opt
                  ? {
                      ...opt,
                      ...param,
                    }
                  : param,
              },
            )
            res = await ajax(options, [], ['/result/handle-error'])
          } else {
            let data = opt ? {
              ...opt,
              ...param,
            } : param
            // 所有列表基金增加workingHours -权限 参数
            const Object_be7l__u = ['Object_be7l__u'].includes(this.$route.params.moduleInfoId) && this.$store.state.user.roleName == '亦庄科创二期LP'
            const objParams = {
              "connector": "and",
              "filterConnector": "or",
              "filters": [
                {
                  "fieldName": "name",
                  "operator": "LIKE",
                  "fieldValues": [
                    "亦庄科创基金二期"
                  ]
                },
                // {
                //   "fieldName": "name",
                //   "operator": "LIKE",
                //   "fieldValues": [
                //     "uE4L4Y"
                //   ]
                // },
                {
                  "fieldName": "Field_hvze__u",
                  "operator": "LIKE",
                  "fieldValues": [
                    "亦庄科创基金二期"
                  ]
                },
                // {
                //   "fieldName": "Field_hvze__u",
                //   "operator": "LIKE",
                //   "fieldValues": [
                //     "uE4L4Y"
                //   ]
                // }
              ]
            }
            if (data.moduleInfoId === 'fund') {
              data.workingHours = true
              if (Object_be7l__u) {
                if (!data.wheres?.length) {
                  data.wheres = []
                  data.wheres.push(objParams)
                } else {
                  data ? data.wheres.push(objParams) : ''
                }
              }
            }
            res = await api({
              data,
            })
          }
          //查询条数过多，限制100000
          if (res && res.code === 301112006) {
            this.$message.error(res.message)
            this.pageInfo.currentPage = this.prevPageSize
            return
          }
          // result 处理
          if (api_back_filter && typeof api_back_filter == 'function') {
            res = await api_back_filter(res, this)
          }

          if (!res || res.length) {
            return
          }
          if (queryFieldsAPI && opt && Object.keys(opt).length > 0) {
            var userFields = await queryFieldsAPI({
              data: opt,
            })
          }
          // 项目交易记录实体 下 按钮菜单有值可增加发送通知按钮
          if (res.meta?.apiName === 'xiangmujiaoyijilu__u' && res.data.tableData.length && res.data.tableData[0].menu) {
            const sendNotification = {
              label: '发送通知',
              type: 'button',
              children: null,
              handle: 'sendNotification',
              random: 'sendNotification',
              style: 'primary',
              functionRight: null,
              command: 'sendNotification',
              buttonInfo: null,
              config: null,
              icon: 'edit',
            }
            if(res.data.tableData.length > 0 ) {
              // res.data.tableData[0].menu = res.data?.tableData?.[0]?.menu.concat(sendNotification)
              res.data.tableData.map((item, i)=> {
                res.data.tableData[i].menu = item.menu.concat(sendNotification)
              })
            }
          }
          // 返投项目指标实体 下 按钮菜单隐藏查看按钮
          if (res.meta?.apiName === 'Object_dfrv__u' && res.data.tableData.length && res.data.tableData[0].menu) {
            if(res.data.tableData.length > 0 ) {
              // res.data.tableData[0].menu = res.data?.tableData?.[0]?.menu.concat(sendNotification)
              res.data.tableData.map((item, i)=> {
                res.data.tableData[i].menu = item.menu.filter(item=>item.random !== 'view')
              })
            }
          }
          // 全部基金门户任务配置表实体下 按钮菜单增加补发按钮
          if (res.meta?.apiName === "fof_fund_task_config__u" && res.data.tableData.length && res.data.tableData[0].menu) {
            const reissueTasks = {
              label: '补发',
              type: 'button',
              children: null,
              handle: 'reissueTasks',
              random: '补发',
              style: 'primary',
              functionRight: null,
              command: 'reissueTasks',
              buttonInfo: null,
              config: null,
            }
            if(res.data.tableData.length > 0 ) {
              res.data.tableData.map((item, i)=> {
                res.data.tableData[i].menu = item.menu.concat(reissueTasks)
              })
            }
          }
          let { data, meta, currentPage, total, pageSize } = res
          if (currentPage > 1 && data.tableData.length === 0) {
            vm.pageInfo.currentPage = vm.pageInfo.currentPage - 1
            await this.queryTableData()
            return
          }
          // vm.$nextTick(() => {
          vm.pageInfo = {
            total: total,
            pageSize: pageSize,
            currentPage: currentPage,
            layout: pageLayout || vm.defaultPageLayout,
            background: pageBackground,
            pageSizes: pageSizes,
          }
          if (data) {
            data = await this.riskManagementRedYellow(data)
            let krTable = this.getKrTable()
            if (krTable) {
              krTable.headerCheck = false
            }
            if(opt && opt.moduleInfoId && ['voting_member__u', 'voter__u', 'vote_detail__u'].includes(opt.moduleInfoId)) {
              vm.headerData = this.handleVoteField(data.headerData, data.tableData)
            } else {
              let moduleId = this.$route.params.moduleInfoId
              const created_by_id = this.$parent?.$parent?.value?.created_by?.[0]?.id == this.userId
              if (['vote_result__u'].includes(moduleId) && ['evaluation_initiator__u'].includes(this.$parent?.$parent?.value?.record_type) && created_by_id) {
                this.lock = 0
              }
              if ((this.metas?.opt?.fileTypeList?.length > 0 && this.lock != 1 && this.lock != 2) || get(this.uploadType,"type") === 'fileUpload') {
                data.headerData.splice(1, 0, {
                  label: '上传',
                  value: 'upload',
                  link: '',
                  codeAttr: null,
                  type: 'upload',
                  width: 38,
                  redirect: null,
                  _isWindow:this.uploadType.type === 'fileUpload' ? true : false,
                })
                // 添加财务文件解析状态
                if(objectDescribeApiName === 'fin_company_reports__u'){
                  data.headerData.push({
                    label: '解析状态',
                    value: 'fileParsingStatus',
                    link: '',
                    codeAttr: null,
                    type: 'TEXT',
                    redirect: null,
                  })
                }
              }
              console.log("🚀 ~ //vm.$nextTick ~ data.headerData:", data.headerData)
              vm.headerData = Object.freeze(data.headerData)
            }
            vm.filterMetas = Object.freeze(data.filterMetas)
            // 直投-投后详情页-投后数据填报页签 列表操作按钮只展示编辑按钮
            // menuLabelName  包含 horizontal 的 需直接隐藏操作列
            const { params: { moduleInfoId }, path } = this.$route
            if(moduleInfoId === 'project' && path.includes('edit') && this.menuLabelName.includes('投后数据填报')){
              const entityBtns = ['Object_zkzu__u']
              data.tableData.map(childItem => {
                const { menu, object_describe_api_name } = childItem
                // 展示 编辑删除两个按钮集合
                if (this.menuLabelName.includes('horizontal')) {
                  childItem.menu = []
                } else {
                  // Object_zkzu__u  企业对接人列表需展示编辑 - 删除 两个按钮
                  const btnList = entityBtns.includes(object_describe_api_name) ? ['update', 'delete'] : ['update']
                  childItem.menu = menu && menu.filter(filterItem => btnList.includes(filterItem?.command)) || []
                }
              })
              // 控制列表查看文件列不显示
              if(meta?.config?.showFileColumn) {
                meta.config.showFileColumn = false
              }
            }

            // 全局变量，JSON 字符串格式
            const Global_0k82__globalString = this.$store?.getters?.['globalVars/gVars']?.Global_0k82__global
            const Global_0k82__global = Global_0k82__globalString && JSON.parse(Global_0k82__globalString)
            const Field_fundfullname__u = this.$parent?.$parent?.value?.Field_fundfullname__u?.[0]?.id
            const current_stage = this.$parent?.$parent?.value?.current_stage
            if(Global_0k82__global && current_stage === '投资尽调' && Global_0k82__global.includes(Field_fundfullname__u)) {
              const optional_file_type_api_name = ['FileType_ktkv__u', 'FileType_vmis__u']
              data.tableData.forEach(item=>{
                if(optional_file_type_api_name.includes(item.file_type_api_name)) {
                  item.required = false
                }
              })
            }

            // 财务报告文件解析状态，数据处理
            if (objectDescribeApiName === 'fin_company_reports__u') {
              data.tableData = data.tableData.map(item => ({
                ...item,
                fileParsingStatus:
                  item.parsingStatus === 1 ? "已解析"
                  : item.parsingStatus === 2 ? `解析失败：${item.parsingErrorMsg || ""}`
                  : "未处理"
              }));
            }
            
            vm.tableData = data.tableData

            const currentTime = new Date().getTime()
            const sevenTime = 24 * 60 * 60 * 7 * 1000
            const processData = {
              zhongdashixiang__u: tableData => {
                if (tableData.zhuangtai__u === '01') {
                  tableData.state = '已完成'
                  tableData.biaoShiFu = 'completed'
                } else if (
                  tableData.zhuangtai__u === '02' &&
                  tableData.fashengriqi__u
                ) {
                  if (tableData.fashengriqi__u - currentTime > sevenTime) {
                    tableData.state = '待处理'
                    tableData.biaoShiFu = 'pending'
                  } else if (currentTime > tableData.fashengriqi__u) {
                    tableData.state = '超时'
                    tableData.biaoShiFu = 'timeOut'
                  } else if (
                    tableData.fashengriqi__u - currentTime <=
                    sevenTime
                  ) {
                    tableData.state = '预警'
                    tableData.biaoShiFu = 'EarlyWarning'
                  }
                }
                return tableData
              },
              Object_weh4__u: tableData => {
                if (tableData.zhuangtai__u === '01') {
                  tableData.state = '已完成'
                  tableData.biaoShiFu = 'completed'
                } else if (
                  tableData.zhuangtai__u === '02' &&
                  tableData.Field_05kj__u
                ) {
                  if (tableData.Field_05kj__u - currentTime > sevenTime) {
                    tableData.state = '待处理'
                    tableData.biaoShiFu = 'pending'
                  } else if (currentTime > tableData.Field_05kj__u) {
                    tableData.state = '超时'
                    tableData.biaoShiFu = 'timeOut'
                  } else if (
                    tableData.Field_05kj__u - currentTime <=
                    sevenTime
                  ) {
                    tableData.state = '预警'
                    tableData.biaoShiFu = 'EarlyWarning'
                  }
                }
                return tableData
              },
              Object_irn4__u: tableData => {
                if (tableData.zhuangtai__u === '01') {
                  tableData.state = '已完成'
                  tableData.biaoShiFu = 'completed'
                } else if (
                  tableData.zhuangtai__u === '02' &&
                  tableData.Field_ruhx__u
                ) {
                  if (tableData.Field_ruhx__u - currentTime > sevenTime) {
                    tableData.state = '待处理'
                    tableData.biaoShiFu = 'pending'
                  } else if (currentTime > tableData.Field_ruhx__u) {
                    tableData.state = '超时'
                    tableData.biaoShiFu = 'timeOut'
                  } else if (
                    tableData.Field_ruhx__u - currentTime <=
                    sevenTime
                  ) {
                    tableData.state = '预警'
                    tableData.biaoShiFu = 'EarlyWarning'
                  }
                }
                return tableData
              },
              Object_7xh1__u: tableData => {
                if (tableData.zhuangtai__u === '01') {
                  tableData.state = '已完成'
                  tableData.biaoShiFu = 'completed'
                } else if (
                  tableData.zhuangtai__u === '02' &&
                  tableData.Field_7t3l__u
                ) {
                  if (tableData.Field_7t3l__u - currentTime > sevenTime) {
                    tableData.state = '待处理'
                    tableData.biaoShiFu = 'pending'
                  } else if (currentTime > tableData.Field_7t3l__u) {
                    tableData.state = '超时'
                    tableData.biaoShiFu = 'timeOut'
                  } else if (
                    tableData.Field_7t3l__u - currentTime <=
                    sevenTime
                  ) {
                    tableData.state = '预警'
                    tableData.biaoShiFu = 'EarlyWarning'
                  }
                }
                return tableData
              },
              Object_dqye__u: tableData => {
                if (tableData.zhuangtai__u === '01') {
                  tableData.state = '已完成'
                  tableData.biaoShiFu = 'completed'
                } else if (
                  tableData.zhuangtai__u === '02' &&
                  tableData.Field_6b45__u
                ) {
                  if (tableData.Field_6b45__u - currentTime > sevenTime) {
                    tableData.state = '待处理'
                    tableData.biaoShiFu = 'pending'
                  } else if (currentTime > tableData.Field_6b45__u) {
                    tableData.state = '超时'
                    tableData.biaoShiFu = 'timeOut'
                  } else if (
                    tableData.Field_6b45__u - currentTime <=
                    sevenTime
                  ) {
                    tableData.state = '预警'
                    tableData.biaoShiFu = 'EarlyWarning'
                  }
                }
                return tableData
              },
            }
            if (vm.tableData && vm.tableData.length && this.layoutType === 'after_invest') {
              vm.tableData = vm.tableData.map(data => {
                const arr = [
                  'zhongdashixiang__u',
                  'Object_weh4__u',
                  'Object_irn4__u',
                  'Object_7xh1__u',
                  'Object_dqye__u',
                ]
                if (
                  data.object_describe_api_name &&
                  arr.includes(data.object_describe_api_name)
                ) {
                  const { object_describe_api_name: apiName } = data
                  return processData[apiName](data)
                }
                return data
              })
            }

            const KEY_MAPPING = {
              zhongdashixiang__u: {
                key: 'zhongdashixiang__status___u',
              },
              yejichengnuochufaqingkuang__u: {
                key: 'yeji__status___u',
              },
              xiangmudingqizoufang__u: {
                key: 'dingqizoufang__status___u',
              },
              guquanxiangmutouhoushixiang__u: {
                key: 'touhoushixiang__status___u',
              },
              jiaoyi__u: {
                key: 'jiaoyi__status___u',
              },
            }
            const STATE_MAPPING = {
              finished: {
                label: '已完成',
                key: 'finished',
                className: 'completed',
              },
              todo: {
                label: '待处理',
                key: 'todo',
                className: 'pending',
              },
              timeout: {
                label: '超时',
                key: 'timeout',
                className: 'timeOut',
              },
              warning: {
                label: '预警',
                key: 'warning',
                className: 'EarlyWarning',
              },
            }
            const getState = (state, date) => {
              const current = new Date().getTime()
              const targetDate = new Date(date).getTime()

              if (state === '01') {
                return 'finished'
              } else if (state === '02' && targetDate) {
                if (current > targetDate) {
                  return 'timeout'
                } else if (targetDate - current <= 24 * 60 * 60 * 7 * 1000) {
                  return 'warning'
                } else {
                  return 'todo'
                }
              } else {
                // eslint-disable-next-line
                console.error(new Error(`unknown state: ${state}`))
              }
            }

            const keys = Object.keys(KEY_MAPPING)
            if (
              this.tableData &&
              this.tableData.length &&
              this.tableData[0].object_describe_api_name === 'project'
            ) {
              this.tableData = this.tableData.map((row, i) => {
                const status = keys.reduce((rs, key) => {
                  const date = row[key]
                  const stateKey = KEY_MAPPING[key].key
                  let state =
                    row[stateKey] && date && getState(row[stateKey], date)
                  const target = `${key}___status`
                  return state
                    ? {
                        ...rs,
                        withTag: true,
                        [target]: STATE_MAPPING[state],
                      }
                    : rs
                }, {})

                return {
                  ...row,
                  status,
                }
              })
            }

            this.defaultData && vm.tableData.unshift(this.defaultData)
            vm.refer = data.refer || {}
            let tableProps = data.tableProps || {}
            if (settingsType) {
              tableProps.settingsType = buttonShow(this.tableData,settingsType)
            }
            if (!tableProps.settingsType) {
              tableProps.settingsType = 'dropdown'
            }
            if (redirects) {
              tableProps.redirects = redirects
            }
            if (related !== undefined) {
              tableProps.related = related
            }
            if (favourite !== undefined) {
              tableProps.favourite = favourite
            }
            if (moveRowKey !== undefined) {
              tableProps.moveRowKey = moveRowKey
            }
            if (fixFirstColumn !== undefined) {
              tableProps.fixFirstColumn = fixFirstColumn
            }
            if (supportMoveRow !== undefined) {
              tableProps.supportMoveRow = supportMoveRow
            }
            if (forceSetHeader) {
              tableProps.forceSetHeader = forceSetHeader
            }

            if (selection) {
              tableProps.selection = selection
            }

            if (skipPageChange) {
              vm.skipPageChange = skipPageChange
            }
            if (skipSortChange) {
              vm.skipSortChange = skipSortChange
            }
            if(this.fieldRight === 'edit' || this.fieldRight === 'required'){
              tableProps.menu = [
                {
                  "label": "编辑",
                  "type": "button",
                  "children": null,
                  "handle": "updateData",
                  "random": "updateData",
                  "style": "primary",
                  "functionRight": null,
                  "command": "update",
                  "buttonInfo": null,
                  "config": null
                },
                // {
                //   "label": "删除",
                //   "type": "button",
                //   "children": null,
                //   "handle": "deleteData",
                //   "random": "deleteData",
                //   "style": null,
                //   "functionRight": null,
                //   "command": "delete",
                //   "buttonInfo": null,
                //   "config": null
                // }
              ]
              tableProps.settingsType = 'button'
            }
            if(this.fieldRight === 'del'){
              tableProps.menu = [
                {
                  "label": "编辑",
                  "type": "button",
                  "children": null,
                  "handle": "updateData",
                  "random": "updateData",
                  "style": "primary",
                  "functionRight": null,
                  "command": "update",
                  "buttonInfo": null,
                  "config": null
                },
                {
                  "label": "删除",
                  "type": "button",
                  "children": null,
                  "handle": "deleteData",
                  "random": "deleteData",
                  "style": null,
                  "functionRight": null,
                  "command": "delete",
                  "buttonInfo": null,
                  "config": null
                }
              ]
              tableProps.settingsType = 'dropdown'
            }
            vm.tableProps = tableProps
            //是否显示分页
            this.isShowPagination = isShowPagination
              ? false
              : true && !hidePagination
          }
          if (meta) {
            meta.total = total
            vm.metaData = meta
            vm.metadataChange(meta)
          }
          if (this.popover) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.popover.updatePopper()
              }, 0)
            })
          }
          if (this.fixedFn) {
            this.fixedFn()
          }
          this.type !== 'gm' && (vm.loading = false)
        } finally {
          this.type !== 'gm' && (vm.loading = false)
        }
      }
    },
    async handleSetHeader() {
      this.setHeaderDialog.visible = true
      this.setHeaderDialog.loading = true
      const { opt, queryFieldsAPI } = this.metas
      if (queryFieldsAPI && opt && Object.keys(opt).length > 0) {
        var userFields = await queryFieldsAPI({
          data: { ...opt },
        })
        if (userFields) {
          this.setHeaderDialog.value = {
            viewFields: userFields.fixedFields,
          }
          this.setHeaderDialog.metas = [
            {
              ...this.setHeaderDialog.metas[0],
              scene: {
                related_data: {
                  options: userFields.allFields.filter(
                    field => !['group', 'standard'].includes(field.type),
                  ),
                },
              },
            },
          ]
        }
      }
      this.setHeaderDialog.loading = false
    },
    async handleSetHeaderConfirmBtn() {
      const { setHeaderForm } = this.$refs
      const value = await setHeaderForm.submit()
      if (value.viewFields && value.viewFields.length === 0) {
        this.$message.error('请选择至少一个显示列')
        return
      }
      await this.setHeader(value.viewFields)
      this.setHeaderDialog.visible = false
    },
    async handleResetHeader() {
      await this.setHeader([])
      this.resetHeaderDialog.visible = false
      this.$nextTick(() => {
        this.setHeaderDialog.visible = false
      })
    },
    async setHeader(viewFields) {
      // header 显示列存储
      const { updateFieldsAPI, opt } = this.metas
      if (updateFieldsAPI) {
        const res = await updateFieldsAPI({
          data: {
            ...opt,
            fields: viewFields.map(field => field.value),
          },
        })
        this.queryTableData()
      }
      this.$emit('handleSetHeader', viewFields)
    },
    getSelectionRows(rows) {
      this.$emit('getSelectionRows', rows)
    },
    // 处理投票的“投票人（外部）-voter_internal__u”和“投票人（外部）-voter_external__u”字段
    handleVoteField(headerData=[], tableData=[]) {
      let headerDataList = headerData.filter(item=> !['voter_internal__u', 'voter_external__u'].includes(item.value))
      const fixed = headerDataList.some((item)=>item?.fixed)
      let fixedIndex = 0
      if (fixed) {
        fixedIndex = headerDataList.findIndex((item)=>item?.fixed) // 找到当前所在的位置
        fixedIndex++ // 在当前所在的位置后面添加数据
      }

      const folderId = this.$route?.params?.folderId
      const name = this.$store.state?.menu?.subMenuActiveMapping[folderId]?.name
      if (name == 'BDG投票信息') {
        const index = headerData.findIndex(item => item.value == 'vote_result__u')
        headerDataList.splice(index, 0, {
          isRequired: null,
          label: "投票人",
          parent: null,
          redirect: false,
          sort: false,
          type: "employee",
          value: "vote_user",
        })
      } else {
        headerDataList.splice(fixedIndex, 0, {
          isRequired: null,
          label: "投票人",
          parent: null,
          redirect: false,
          sort: false,
          type: "employee",
          value: "vote_user",
        })
      }
      tableData.forEach(item=>{
        item.vote_user = item.voter_internal__u?.[0]?.name || item.voter_external__u
      })
      return headerDataList
    }
  },
  watch: {
    metas: {
      handler(v) {
        if (v.opt.pageSize) {
          let pageCurrentMemory =
            window.sessionStorage.getItem('pageCurrentMemory') || ''
          let name = this.$route.name
          if (pageCurrentMemory && this.metas.opt) {
            pageCurrentMemory = JSON.parse(pageCurrentMemory)
            if (
              name == 'mdSettingsBusinessCustomizationObjectManage' ||
              name == 'mdSettingsBusinessCustomizationTabManage' ||
              name == 'mdSettingsScriptManageConfig' ||
              name == 'mdSettingsScriptManageLog' ||
              name == 'mdSettingsMeetingManage' ||
              name == 'mdSettingsSecurityManageOperationLog' ||
              name == 'mdSettingsSecurityManageLoginLog' ||
              name == 'mdSettingsJurisdictionManageFunctionJurisdiction' ||
              name == 'mdSettingsBusinessCustomizationinGlobalVariable'
            ) {
              this.pageInfo.currentPage = pageCurrentMemory[name] || 1
            } else if (
              name == 'mdSettingsBusinessCustomizationinstrumentChange'
            ) {
              if (this.metas.opt.filters[0]) {
                if (this.metas.opt.filters[0].fieldValues[0]) {
                  this.pageInfo.currentPage =
                    pageCurrentMemory[
                      this.metas.opt.filters[0].fieldValues[0].system_default
                    ] || 1
                }
              }
            } else if (
              name == 'mdSettingsBusinessCustomizationObjectManageDetail'
            ) {
              if (this.typeObject) {
                this.pageInfo.currentPage =
                  pageCurrentMemory[this.typeObject] || 1
              }
            } else {
              if (
                this.metas.opt.moduleInfoId == 'Object_41ix__u' ||
                this.metas.opt.moduleInfoId == 'project' ||
                this.metas.opt.moduleInfoId == 'company'
              ) {
                if (pageCurrentMemory[this.metas.opt.moduleInfoId]) {
                  if (
                    this.$route.query.mid ==
                    pageCurrentMemory[this.metas.opt.moduleInfoId].menuId
                  ) {
                    this.pageInfo.currentPage =
                      pageCurrentMemory[this.metas.opt.moduleInfoId].current ||
                      1
                  }
                }
              } else {
                this.pageInfo.currentPage =
                  pageCurrentMemory[this.metas.opt.moduleInfoId] || 1
              }
            }
          }
          this.pageInfo.pageSize = v.opt.pageSize
        }
        this.queryTableData()
      },
      deep: true,
      // immediate: true
    },
    defaultData: {
      handler(val) {
        this.tableData.map(v => (v.tabId = val.tabId))
      },
      deep: true,
    },
  },
}
</script>
